import { BatteryCharging, Thermometer, ShieldCheck } from "@phosphor-icons/react";

const STEPS = [
  { n: "01", icon: BatteryCharging, title: "Charge", body: "Plug in via USB-C. Full charge in under 3 hours." },
  { n: "02", icon: Thermometer, title: "Set your temperature", body: "Dial in your exact target between 2–8°C on the digital display." },
  { n: "03", icon: ShieldCheck, title: "Store with confidence", body: "Drop in your vials. CryoVault holds the cold chain 24/7." },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works"
      className="py-14 sm:py-20 bg-white border-y border-[#8A97A8]/20"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="overline text-cyan-brand">How it works</div>
          <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-[54px] font-bold text-navy-deep tracking-tight leading-[1.05]">
            Three steps. Total peace of mind.
          </h2>
        </div>
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {STEPS.map((s) => (
            <div
              key={s.n}
              className="reveal rounded-3xl bg-cool-white border border-[#8A97A8]/25 p-8"
            >
              <div className="flex items-start gap-4">
                <div className="font-mono-data text-teal-brand text-lg font-semibold">
                  {s.n}
                </div>
                <div className="h-11 w-11 rounded-2xl bg-white border border-[#8A97A8]/25 grid place-items-center text-royal">
                  <s.icon size={22} weight="regular" />
                </div>
              </div>
              <h3 className="mt-6 text-navy-deep font-display font-bold text-xl">
                {s.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
